module.exports = __webpack_public_path__ + "img/translationeditor_16.1c26ec0a.jpg";